import request from '@/utils/request';
//会员列表
export function getMemberList(param) {
  return request('/ec/member/queryMemberPage', {
    method: 'POST',
    data: param,
  });
}
//总数据条数
export function getTotalData() {
  return request('/ec/member/queryMemberCount', {
    method: 'GET',
    // data: param,
  });
}
//获取等级列表
export function getLevels() {
  return request('/config/queryLevels', {
    method: 'GET',
  });
}
//门店列表
export function getStoreList(values) {
  return request('/ec/store/queryPage', {
    method: 'POST',
    data: values,
  });
}

//新增会员列表
export function addMember(values) {
  return request('/ec/membership/members', {
    method: 'POST',
    data: values,
  });
}
